export default __webpack_public_path__ + "static/media/flag-rwanda.b10b7b02.svg";